// useEffectiveDojo.ts - ENHANCED WITH IMPERSONATION
import { useAuth } from '@/contexts/AuthContext';

/**
 * Helper hook that returns the effective dojo_id and context
 * Handles impersonation for super users
 */
export const useEffectiveDojo = () => {
  const { profile, impersonation } = useAuth();
  
  const isSuperUser = profile?.role === 'super_user';
  const isAdmin = profile?.role === 'admin';
  const isImpersonating = impersonation.active;
  
  // Determine effective dojo context
  let effectiveDojoId: string | null = null;
  let effectiveDojoName: string | null = null;
  let shouldFilterByDojo = true;
  
  if (isImpersonating && impersonation.dojoId) {
    // During impersonation, use the selected dojo
    effectiveDojoId = impersonation.dojoId;
    effectiveDojoName = impersonation.dojoName || null;
    shouldFilterByDojo = true; // Always filter during impersonation
  } else if (isSuperUser && !isImpersonating) {
    // Super user not impersonating - global access
    effectiveDojoId = null;
    effectiveDojoName = null;
    shouldFilterByDojo = false;
  } else {
    // Regular admin/student - use their assigned dojo
    effectiveDojoId = profile?.dojo_id || null;
    effectiveDojoName = null;
    shouldFilterByDojo = true;
  }
  
  return {
    effectiveDojoId,
    effectiveDojoName,
    isSuperUser,
    isAdmin,
    isImpersonating,
    shouldFilterByDojo,
    // Helper method to check if current context should see specific dojo data
    canAccessDojo: (dojoId: string) => {
      if (isSuperUser && !isImpersonating) return true; // Global access
      if (isImpersonating) return dojoId === impersonation.dojoId; // Only impersonated dojo
      return dojoId === profile?.dojo_id; // Only own dojo
    }
  };
};
